import React from 'react';
import { useTranslation } from 'react-i18next';
import Section from '../Section';
import BlogSectionStyle2 from '../Section/BlogSection/BlogSectionStyle2';
import Breadcrumb from '../Breadcrumb';
import { pageTitle } from '../../helpers/PageTitle';
import SEO from '../SEO';

export default function Blog() {
  const { t } = useTranslation();

  const blogData = [
    {
      title: t('blog.blog1Title'),
      thumbUrl: 'images/blog/blog_1.jpeg',
      date: t('blog.blog1Date'),
      btnText: t('blog.readMore'),
      href: '/blog/dializa-peritoneale',
    },
    {
      title: t('blog.blog2Title'),
      thumbUrl: 'images/blog/blog_2.jpg',
      date: t('blog.blog2Date'),
      btnText: t('blog.readMore'),
      href: '/blog/diabeti',
    },
    {
      title: t('blog.blog3Title'),
      thumbUrl: 'images/blog/blog_3.jpg',
      date: t('blog.blog3Date'),
      btnText: t('blog.readMore'),
      href: '/blog/kanceri',
    },
  ];

  pageTitle(t('blog.pageTitle'));
  return (
    <>
      <SEO title="Blog" description="Artikuj dhe informacione mbi shëndetësinë, farmakologjinë dhe inovacionet medicinale nga Incomed." url="/blog" />
      <Section topMd={170} bottomMd={96} bottomLg={70}>
        <Breadcrumb title={t('blog.bannerTitle')} />
      </Section>
      <Section bottomMd={200} bottomLg={150} bottomXl={110}>
        <BlogSectionStyle2 data={blogData} />
      </Section>
    </>
  );
}
